import {Injectable} from "@angular/core";
import {
	Alt,
	Ctrl,
	keyboardMap,
	keyCodesToTranslate, numberKeyCodes, numPadNumbersKeyCodes,
	Shift
} from "../keyboard.map";
import {TranslateService} from "../../translate";

@Injectable({ providedIn: 'root' })
  export class HotKeyUtils {

	public SEPARATOR = "+";

	public WL_ACTIONS_CATEGORY_ID = 'WorklistActions';
	public WL_ACTIONS_CATEGORY_NAME = 'WorklistActionsCategory';
	public GLOBAL_ACTIONS_CATEGORY_ID = 'GlobalActions';
	public GLOBAL_ACTIONS_CATEGORY_NAME = 'GlobalActionsCategory';
	public COMMON_SESSION_ACTIONS_CATEGORY_ID = 'CommonSessionActions';
	public COMMON_SESSION_ACTIONS_CATEGORY_NAME = 'CommonSessionActionsCategory';
	public RIS_ACTIONS_CATEGORY_ID = 'RISActions';
	public RIS_ACTIONS_CATEGORY_NAME = 'RISActionsCategory';
	public SYSTEM_ACTIONS_CATEGORY_ID = 'SystemActions';
	public SYSTEM_ACTIONS_CATEGORY_NAME = 'SystemActionsCategory';
	public PATIENT_CHART_CATEGORY_ID = 'PatientChart';

	constructor(private translateService:TranslateService) {
	}

	public toString(hotkey: string) {
		if (hotkey) {
			return hotkey.split(this.SEPARATOR).reduce((hotkeyStr, keyCode, i) => {
				return hotkeyStr + (i !== 0 ? ' ' + this.SEPARATOR + ' ' : '') +
					(keyCodesToTranslate.find( c => c === keyboardMap[+keyCode]) ?
								<string>this.translateService.instant('KEY_' + keyboardMap[+keyCode] + '.Message') : keyboardMap[+keyCode]);
			}, "");
		}
	}

	public toCodedString(event: KeyboardEvent) {
		let shortcut = "";
		if (event.ctrlKey) {
			shortcut += Ctrl.toString() + this.SEPARATOR;
		}
		if (event.altKey) {
			shortcut += Alt.toString() + this.SEPARATOR;
		}
		if (event.shiftKey) {
			shortcut += Shift.toString() + this.SEPARATOR;
		}
		if (numPadNumbersKeyCodes.includes(event.keyCode)) {
			shortcut += numberKeyCodes[event.keyCode - 96];
		} else {
			shortcut += event.keyCode;
		}
		return shortcut;
	}
}
